import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.995 2.83801L7.995 13.4005M3.12 7.30676L7.71062 2.71614C7.78656 2.6417 7.88866 2.60001 7.995 2.60001C8.10133 2.60001 8.20343 2.6417 8.27937 2.71614L12.87 7.30676",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgArrowUp;
